export default __webpack_public_path__ + "static/media/Welcome2.9ef208fe.jpg";